export default {
  CONFIRM_PASSWORD: 'Wachtwoord bevestigen',
  FORGOT_PASSWORD_CAPTION: 'Maak je geen zorgen. Voer uw gebruikersnaam in en we delen een resetlink op het geregistreerde e-mailadres.',
  PASSWORD_EMAIL_SUCCESS: 'Er is een nieuw wachtwoord verzonden naar uw geregistreerde e-mailadres',
  SENT_EMAIL_TITLE: 'Nieuw wachtwoord verzonden',
  INVALID_RESET_PASS_LINK: 'Het lijkt erop dat de link voor het opnieuw instellen van uw wachtwoord ongeldig is, probeer het opnieuw.',
  RESET_PASS_SUCCESS: 'Uw wachtwoord is succesvol gereset, log in.',
  RESET_PASS_LINK_EXPIRED: 'Het lijkt erop dat de link voor het opnieuw instellen van uw wachtwoord is verlopen, probeer het opnieuw.',
  PASSWORDS_NOT_SAME: 'Wachtwoord en bevestigingswachtwoord moeten hetzelfde zijn',
  RESET_PASSWORD: 'Wachtwoord opnieuw instellen',
  RESET_PASSWORD_CAPTION: 'Voer uw nieuwe wachtwoord in en klik op de knop Verzenden.'
}
